import { useEffect, useState } from "react";
import api from "../lib/api";
import { Mail, X, Send } from "lucide-react";
import { toast } from "sonner";

export const EmailModal = ({ docType, docId, defaultTo = "", defaultSubject = "", defaultBody = "", onClose }) => {
    const [form, setForm] = useState({ to: defaultTo, subject: defaultSubject, body: defaultBody });
    const [busy, setBusy] = useState(false);
    const [clients, setClients] = useState([]);

    useEffect(() => {
        if (!defaultTo) api.get("/clients").then((r) => setClients(r.data.filter((c) => c.email))).catch(() => {});
    }, [defaultTo]);

    const send = async () => {
        if (!form.to) { toast.error("Zadejte e-mail příjemce"); return; }
        setBusy(true);
        try {
            await api.post(`/email/${docType}/${docId}`, form);
            toast.success(`E-mail odeslán na ${form.to}`);
            onClose(true);
        } catch (e) {
            toast.error(e.response?.data?.detail || "Odeslání selhalo");
        } finally { setBusy(false); }
    };

    return (
        <div className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={() => !busy && onClose(false)}>
            <div className="bg-white border-2 border-slate-900 max-w-lg w-full" onClick={(e) => e.stopPropagation()} data-testid="email-modal">
                <div className="flex items-center justify-between px-6 py-4 border-b-2 border-slate-900">
                    <div className="flex items-center gap-2">
                        <Mail className="w-5 h-5 text-orange-600" />
                        <h2 className="font-display text-lg font-bold">Odeslat e-mailem</h2>
                    </div>
                    {!busy && <button onClick={() => onClose(false)}><X className="w-5 h-5 text-slate-400 hover:text-slate-900" /></button>}
                </div>
                <div className="p-6 space-y-4">
                    <div>
                        <label className="label-eyebrow block mb-1.5">Příjemce *</label>
                        <input type="email" value={form.to} onChange={(e) => setForm({ ...form, to: e.target.value })} data-testid="email-to"
                               placeholder="klient@email.cz" list="email-clients"
                               className="w-full px-3 py-2 border border-slate-300 text-sm focus:outline-none focus:ring-2 focus:ring-orange-600 rounded-sm" />
                        <datalist id="email-clients">
                            {clients.map((c) => <option key={c.id} value={c.email}>{c.name}</option>)}
                        </datalist>
                    </div>
                    <div>
                        <label className="label-eyebrow block mb-1.5">Předmět *</label>
                        <input value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} data-testid="email-subject"
                               className="w-full px-3 py-2 border border-slate-300 text-sm focus:outline-none focus:ring-2 focus:ring-orange-600 rounded-sm" />
                    </div>
                    <div>
                        <label className="label-eyebrow block mb-1.5">Text zprávy</label>
                        <textarea rows={7} value={form.body} onChange={(e) => setForm({ ...form, body: e.target.value })} data-testid="email-body"
                                  className="w-full px-3 py-2 border border-slate-300 text-sm focus:outline-none focus:ring-2 focus:ring-orange-600 rounded-sm resize-none" />
                    </div>
                    <p className="text-xs text-slate-500">PDF dokument bude automaticky připojen jako příloha. Odesílá se přes SMTP nastavené v Nastavení firmy.</p>
                </div>
                <div className="flex gap-2 px-6 py-4 bg-slate-50 border-t border-slate-200 justify-end">
                    <button onClick={() => onClose(false)} disabled={busy} className="px-4 py-2 text-xs uppercase tracking-wider border border-slate-300 hover:bg-slate-100 rounded-sm">Zrušit</button>
                    <button onClick={send} disabled={busy} data-testid="email-send"
                            className="px-5 py-2 text-xs uppercase tracking-wider font-semibold bg-orange-600 hover:bg-orange-700 text-white rounded-sm inline-flex items-center gap-1.5 disabled:opacity-50">
                        <Send className="w-3.5 h-3.5" /> {busy ? "Odesílám…" : "Odeslat"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default EmailModal;
